'use client';

import { useEffect, useState } from 'react';

import { api } from '@/lib/api';
import { accountError, leaveIfSignedOut } from '@/lib/platform/accounts';
import { parsePlatformSummary, type PlatformSummary } from '@/lib/platform/summary';

export function usePlatformSummary(fallback: string): {
  overview: PlatformSummary | null;
  error: string | null;
  reload: () => void;
} {
  const [overview, setOverview] = useState<PlatformSummary | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [reloadKey, setReloadKey] = useState(0);

  useEffect(() => {
    let cancelled = false;
    api<unknown>('/api/platform/overview')
      .then((payload) => {
        if (cancelled) return;
        setOverview(parsePlatformSummary(payload));
        setError(null);
      })
      .catch((err: unknown) => {
        if (cancelled || leaveIfSignedOut(err)) return;
        setOverview(null);
        setError(accountError(err, fallback));
      });
    return () => {
      cancelled = true;
    };
  }, [fallback, reloadKey]);

  return { overview, error, reload: () => setReloadKey((current) => current + 1) };
}
